(() => {
  const allowed = {
    source: ['ask-mom'],
    utm_source: ['instagram', 'tiktok'],
    utm_medium: ['social'],
    utm_campaign: ['profile'],
  };

  const clean = (values) => Object.fromEntries(
    Object.entries(allowed).flatMap(([key, choices]) => (
      choices.includes(values?.[key]) ? [[key, values[key]]] : []
    )),
  );

  const initialize = () => {
    const sheet = document.querySelector('.bw-mom');
    const form = document.querySelector('.bpc-form');
    if (!sheet && !form) return;

    document.querySelectorAll('[data-mom-print]').forEach((button) => {
      if (button.dataset.bwPrintReady || typeof window.print !== 'function') return;
      button.dataset.bwPrintReady = 'true';
      button.hidden = false;
      button.addEventListener('click', () => window.print());
    });

    const params = new URLSearchParams(window.location.search);
    const attribution = clean(Object.fromEntries(
      Object.keys(allowed).flatMap((key) => (
        params.getAll(key).length === 1 ? [[key, params.get(key)]] : []
      )),
    ));
    if (sheet) attribution.source = 'ask-mom';

    document.querySelectorAll('[data-bw-funnel-link]').forEach((link) => {
      const target = new URL(link.href, window.location.origin);
      if (target.origin !== window.location.origin) return;
      Object.entries(attribution).forEach(([key, value]) => target.searchParams.set(key, value));
      link.href = `${target.pathname}${target.search}${target.hash}`;
    });
    form?.querySelectorAll('[data-bw-funnel-param]').forEach((field) => {
      field.value = attribution[field.dataset.bwFunnelParam] || '';
    });

    const purpose = form?.querySelector('[data-bw-enquiry-purpose]');
    if (purpose && !purpose.dataset.bwFunnelReady) {
      purpose.dataset.bwFunnelReady = 'true';
      if (params.getAll('request').length === 1 && params.get('request') === 'call') {
        purpose.value = 'Free 15-minute call';
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
